import aponeo from './aponeo';
import { themeAssetUrl } from './themeAssets';

export default () => {
  const $pswpContainer = $(
    '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button><button class="pswp__button pswp__button--share" title="Share"></button><button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button><button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button><button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>',
  );

  // Helper function to create video element for PhotoSwipe
  const createVideoElement = (src, videoId, poster) => {
    return `<div class="pswp-video-wrapper" id="${videoId}-wrapper">
      <video id="${videoId}" controls muted preload="none" poster="${poster}">
        <source src="${src}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>`;
  };

  // Initialize PhotoSwipe with both images and videos
  const initiatePhotoSwipe = ($zoomImages, $videoItems = []) => {
    const openPhotoSwipe = (index) => {
      const options = {
        index: index,
        bgOpacity: 0.75,
        shareEl: false,
        captionEl: false,
        // Add custom event handlers for videos
        listeners: {
          beforeChange: function () {
            // Pause all videos when navigating between items
            $('.pswp-video-wrapper video').each(function () {
              if (!this.paused) {
                this.pause();
              }
            });
          },
        },
      };
      let items = [];

      if ($zoomImages.first().data('photoswipeConfig') === 'app-landing-page') {
        // only add 1 image
        items = [
          {
            html: '<img class="apn-landingpage-pop-up" src="/images/resplayout/app_landingpage_pop-up.jpg" alt="APONEO App jetzt im App Store gratis herunterladen!" />',
          },
        ];
      } else {
        // Add regular images
        $zoomImages.each((i, el) => {
          const elem = $(el);
          items.push({
            src: elem.data('photoswipeSrc'),
            w: elem.data('photoswipeDim'),
            h: elem.data('photoswipeDim'),
          });
        });

        // Add video items
        $videoItems.each((i, el) => {
          const elem = $(el);
          const videoSrc = elem.attr('href');
          const videoId = elem.data('video-id');
          const videoPoster = elem.data('poster');
          const width = elem.data('pswp-width') || 1280;
          const height = elem.data('pswp-height') || 720;

          items.push({
            html: createVideoElement(videoSrc, videoId, videoPoster, width, height),
            w: width,
            h: height,
            title: '', // Leerer Titel für Video-Element
          });
        });
      }

      const gallery = new PhotoSwipe($pswpContainer.get(0), PhotoSwipeUI_Default, items, options);

      // Fix für den Caption-Fehler
      gallery.listen('gettingData', function (index, item) {
        if (item.html && !item.title) {
          item.title = '';
        }
      });

      gallery.init();
    };

    $('body').append($pswpContainer);

    // Attach click handlers to images
    $zoomImages.each((i, el) => {
      $(el).on('click.Photoswipe', (event) => {
        event.preventDefault();
        openPhotoSwipe(i);
      });
    });

    // Attach click handlers to videos
    $videoItems.each((i, el) => {
      $(el).on('click.Photoswipe', (event) => {
        event.preventDefault();
        // Videos appear after all images
        openPhotoSwipe($zoomImages.length + i);
      });
    });

    // Prevent default browser behavior for video links
    $(document).on('click', '.pswp-video-item', function (e) {
      e.preventDefault();
    });
  };

  const loadPhotoswipe = ($zoomImages, $videoItems) => {
    const css = themeAssetUrl('css', 'photoswipe.css');
    $.loadStylesheet(css);
    $.cachedScript(themeAssetUrl('js', 'photoswipe.js'))
      .done(() => {
        initiatePhotoSwipe($zoomImages, $videoItems);
      })
      .fail((jqxhr, settings, exception) => {
        console.error('Fehler beim Laden von PhotoSwipe:', exception);
      });
  };

  $(document).ready(() => {
    const $zoomImages = $('.js-photoswipe-zoom');
    const $videoItems = $('.pswp-video-item');

    if ($zoomImages.length || $videoItems.length) {
      loadPhotoswipe($zoomImages, $videoItems);
    }
  });
};
